export default __webpack_public_path__ + "static/media/referrers-icon-active.8b8c7e81.svg";